import { takeEvery, put, fork, call, all } from 'redux-saga/effects';
import { actions as regionReducerActions, callTypes as regionReducerCallTypes } from "./regionSlice"
import { getAllRegionsApi, searchRegionsApi } from "./regionAPI";
import * as uis from "../../../UI/redux/uiSlice";
import logman from '../../../../../utilities/logman';

export function* onLoadRegionsStartAsync(){

    try{
        
        yield put(regionReducerActions.startCall({ callType: regionReducerCallTypes.list }));
        
        const response = yield call(getAllRegionsApi);       
        
        if(response.status === 200){
            let entities = response.data ? response.data : [];
            let totalCount = entities.length;
            yield put(regionReducerActions.regionsLoaded({entities, totalCount}));
        }
    }
    catch(error){
        logman.error(error)
        if(error.response.status === 403){

            let status = error.response.status;
            let msg = "Forbidden. You do not have access to view this page.";

            yield put(uis.actions.error({ status, msg }));
            
        } else if(error.response.status === 404){

            let status = error.response.status;
            let msg = "Page Not Found.";

            yield put(uis.actions.error({ status, msg }));
        } else if(error.response.status === 500){

            let status = error.response.status;
            let msg = "Internal Error";

            yield put(uis.actions.error({ status, msg }));
        }

        // yield put(uis.actions.showNotification({
        //     status:"error",
        //     title:"Error",
        //     message: "There was an error retrieving the regions."
        // }));

        yield put(regionReducerActions.catchError({
            callType: regionReducerCallTypes.list,
            error: "There was an error retrieving the regions."
        }));

    }

};

export function* onSearchRegionsStartAsync({payload}){

    try{
        
        yield put(regionReducerActions.startCall({ callType: regionReducerCallTypes.list }));

        // const getAuth = (state) => state.auth;
        // const auth = yield select(getAuth);

        // let reqBody = {
        //     username: auth.userName,
        //     sessionKey: auth.sessionKey,
        //     string: payload.query
        // };

        // const response = yield call(searchProvincesApi, reqBody); 

        const response = yield call(searchRegionsApi, payload.query);    
        
        if(response.status === 200){
            let entities = response.data;
            let totalCount = entities.length;
            yield put(regionReducerActions.regionsLoaded({entities, totalCount}));
        }
    }
    catch(error){
        
        if(error.response.status === 403){

            let status = error.response.status;
            let msg = "Forbidden. You do not have access to view this page.";

            yield put(uis.actions.error({ status, msg }));
            
        } else if(error.response.status === 404){

            let status = error.response.status;
            let msg = "Page Not Found.";

            yield put(uis.actions.error({ status, msg }));
        } else if(error.response.status === 500){

            let status = error.response.status;
            let msg = "Internal Error";

            yield put(uis.actions.error({ status, msg }));
        }

        // yield put(uis.actions.showNotification({
        //     status:"error",
        //     title:"Error",
        //     message: "There was an error while searching for the regions."
        // }));

        yield put(regionReducerActions.catchError({
            callType: regionReducerCallTypes.list,
            error: "There was an error while searching for the regions."
        }));

    }

};

export const actionTypes = {
    FetchAllRegions: "[FetchAllRegions] Fetch All Regions API Action",
    SearchRegions: "[SearchRegions] Search Regions API Action",
};

export const actions = {

    fetchAllRegions: () => ({ type: actionTypes.FetchAllRegions, payload: { undefined } }),
    searchRegions: (query) => ({ type: actionTypes.SearchRegions, payload: { query } }),

};

export function* fetchAllRegions(){

    yield takeEvery(actionTypes.FetchAllRegions, onLoadRegionsStartAsync);    
};

export function* searchRegions(){

    yield takeEvery(actionTypes.SearchRegions, onSearchRegionsStartAsync);    
};


const fSagas = [
    fork(fetchAllRegions),
    fork(searchRegions),

];

export function* saga(){
    yield all ([...fSagas]);
};
